// @ts-nocheck
/* eslint-disable */
/* NOTE: Auto-generated. Run `yarn build-icons` instead of editing. */
import { ReactComponent as MinusDefault } from '../../../assets/icons/default/general/minus.svg?react';
import { ReactComponent as MinusSolid } from '../../../assets/icons/solid/general/MINUS.svg?react';
import { createIcons } from '../../Icon';
const MinusIcon = /* @__PURE__ */ createIcons('Minus', {
    default: MinusDefault,
    solid: MinusSolid
});
MinusIcon.supportedTypes = ['default', 'solid'];
MinusIcon.category = 'general';
export default MinusIcon;
